module.exports = __webpack_public_path__ + "static/media/control_de_versiones_badge.4fe455a7.png";